function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import PropTypes from 'prop-types';
import { SignInType } from '@domain-group/fe-allhomes-library';
import Option from './option';
import browseOptionsWrapper from './wrapper';
import { OptionMap } from './option-map';
import * as styles from './options.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
class Options extends React.Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "openSignIn", (event, url) => {
      event.preventDefault();
      event.stopPropagation();
      if (this.props.isSignedIn) {
        this.redirect(url);
      } else {
        this.props.openSignIn(SignInType.PROPERTY_ALERT).then(success => {
          if (success) {
            this.redirect(url);
          }
        });
      }
    });
    _defineProperty(this, "redirect", url => {
      if (typeof window !== 'undefined') {
        window.location.href = url;
      }
    });
  }
  render() {
    var mobile = this.props.media.mobile;
    return ___EmotionJSX("div", {
      css: styles.container
    }, this.props.title ? ___EmotionJSX("div", {
      css: styles.title
    }, this.props.title) : null, ___EmotionJSX("div", null, this.props.items.map((item, index) => {
      if (mobile && item.label === OptionMap.notification.label) {
        return ___EmotionJSX(Option, _extends({
          key: item.label
        }, item, {
          type: "secure",
          onClick: event => {
            this.openSignIn(event, item.href);
          },
          position: index
        }));
      }
      return ___EmotionJSX(Option, _extends({
        key: item.label
      }, item, {
        position: index
      }));
    })));
  }
}
Options.propTypes = {
  title: PropTypes.string,
  items: PropTypes.arrayOf(PropTypes.shape(Option.propTypes)),
  isSignedIn: PropTypes.bool,
  openSignIn: PropTypes.func,
  media: PropTypes.shape({
    mobile: PropTypes.bool
  })
};
Options.defaultProps = {
  title: '',
  items: [],
  isSignedIn: false,
  openSignIn: () => Promise.resolve(),
  media: {}
};
export default browseOptionsWrapper(Options);
export { Options as BaseOptions };